import {
  api,
  apiCall,
  apiActionDispatcher
} from './api';

import {
  fetchUserConfigurationActionTypes,
  updateUserConfigurationActionTypes
} from './types';

import { auth } from './../helpers';

export const TOGGLE_PROFILE_FAVORITES = 'TOGGLE_PROFILE_FAVORITES';
export const toggleProfileFavorites = () => ({ type: TOGGLE_PROFILE_FAVORITES });

/**
 * The dispatcher for the fetch user configuration action.
 *
 * @returns {Object} The action dispatcher.
 */
const fetchUserConfigurationDispatcher = apiActionDispatcher(
  {
    actionTypes: fetchUserConfigurationActionTypes,
    responseHandler: userConfiguration => {
      if (!userConfiguration) {
        return userConfiguration;
      }
      const result = {
        ...userConfiguration,
        'custom_nav': userConfiguration && userConfiguration.custom_nav &&
          JSON.parse(userConfiguration.custom_nav)
      };
      return result;
    },
    errorMessage: 'Failed to fetch user configuration'
  }
);

/**
 *
 * Action to fetching the user configuration. Will fetch the user
 * configuration from the backend endpoint if the user is logged in AND
 * the configuration hasn't already been fetched.
 *
 * @param {String} username - The logged in user.
 * @returns {Object} The user configuration.
 */
export const fetchUserConfiguration = (username) => apiCall(
  fetchUserConfigurationDispatcher,
  api.userConfiguration.fetchUserConfiguration,
  state => state.profile.userConfiguration.username !== '' || !auth.checkAuthenticated(),
  null,
  null,
  [username]
);

/**
 *
 * The dispatcher for the update user configuration action.
 *
 * @param {Object} userConfiguration - The user configuration to update.
 * @returns {Object} The action dispatcher.
 */
const updateUserConfigurationDispatcher = (userConfiguration) => apiActionDispatcher(
  {
    actionTypes: updateUserConfigurationActionTypes,
    responseHandler: () => userConfiguration,
    errorMessage: 'Failed to update user configuration'
  }
);

/**
 *
 * Action for updating the user configuration. If logged in, will invoke the backend
 * endpoint to update the user config as well as updating the config in the store.
 * If not logged in, will only update the user configuration in the store.
 *
 * @param {Object} userConfiguration - The new user configuration.
 * @returns {Promise<boolean>} Whether the user configuration was updated successfully.
 */
export const updateUserConfiguration = (userConfiguration) =>
  auth.checkAuthenticated() ? apiCall(
    updateUserConfigurationDispatcher(userConfiguration),
    api.userConfiguration.updateUserConfiguration,
    null,
    null,
    null,
    [userConfiguration]
  ) : () => {
    localStorage.setItem('dark', userConfiguration.darkMode);
    return true;

  };


// WEBPACK FOOTER //
// src/actions/profile.js